import React from 'react';
import { StyleSheet, View } from './base_components';
import LinkImageButton from './buttons/link_image_button';
import ImageButton from './buttons/image_button';

const styles = StyleSheet.create({
  header: {
    alignSelf: 'stretch',
    height: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--topbar-bg-color)',
    borderBottomColor: 'var(--topbar-border-color)',
    '@media (max-width: 600px)': {
      borderBottomWidth: 1,
      height: '6rem !important',
    },
    overflow: 'hidden',
  },
  show: {
    borderBottomWidth: 1,
    height: '6rem !important',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    marginLeft: '1rem',
    width: '10rem',
    height: '2.8rem',
    marginRight: '1rem',
    //filter: 'var(--icon-header-grey)',
  },
  menu: {
    marginLeft: '1rem',
    height: '2rem',
    width: '2rem',
    padding: '1rem',
    filter: 'var(--icon-grey)',
  },
});

const LOGO = require('../assets/img/logo.png');
const MENU = require('../assets/img/collapse_black.svg');

export default function Header(props) {
  const { style, closed } = props;
  return (
    <>
      <View style={[styles.header, closed ? styles.show : null, style]}>
        <ImageButton style={styles.menu} source={MENU} onPress={props.onMenu} />
        <LinkImageButton
          style={styles.logo}
          source={LOGO}
          resizeMode='contain'
          url='/'
        />
        <View style={styles.spacer} />
      </View>
    </>
  );
}
